import { useState } from 'react';
import { mockTools } from './data/mockTools';


export const Reviews = ({ toolId }) => {
  const [newReview, setNewReview] = useState({
    rating: 5,
    comment: ''
  });

  const tool = mockTools.find(t => t.id === toolId);
  const reviews = tool?.reviews || [];

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real app, this would be an API call
    console.log('Submitting review:', newReview);
    setNewReview({ rating: 5, comment: '' });
  };

  return (
    <div className="reviews-section">
      <h2>Reviews</h2>
      
      <div className="reviews-list">
        {reviews.map(review => (
          <div key={review.id} className="review-card">
            <div className="review-header">
              <div className="review-author">{review.userName}</div>
              <div className="review-date">{new Date(review.date).toLocaleDateString()}</div>
            </div>
            <div className="review-rating">
              {'★'.repeat(review.rating)}
              {'☆'.repeat(5 - review.rating)}
            </div>
            <p className="review-comment">{review.comment}</p>
          </div>
        ))}
      </div>

      <form onSubmit={handleSubmit} className="review-form">
        <h3>Write a Review</h3>
        <div className="form-group">
          <label>Rating</label>
          <select
            value={newReview.rating}
            onChange={(e) => setNewReview(prev => ({ ...prev, rating: Number(e.target.value) }))}
            className="select-input"
          >
            {[5, 4, 3, 2, 1].map(rating => (
              <option key={rating} value={rating}>
                {'★'.repeat(rating)}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label>Your Review</label>
          <textarea
            value={newReview.comment}
            onChange={(e) => setNewReview(prev => ({ ...prev, comment: e.target.value }))}
            className="text-input"
            rows={4}
            placeholder="Share your experience with this tool..."
            required
          />
        </div>
        <button type="submit" className="button button-primary">
          Submit Review
        </button>
      </form>
    </div>
  );
}; 